import {
  Fact
} from '../../common/fact';

require('./facts-slider-timeline.component.scss');

export const FactsSliderTimelineComponent = function() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./facts-slider-timeline.component.html'),
    link: function(scope, element, attrs) {
      const onWheel = (e) => {
        const delta = e.originalEvent.deltaY;
        if (delta > 0) {
          scope.$ctrl.leaf(1);
        } else {
          scope.$ctrl.leaf(-1);
        }
      };
      element.bind('wheel', onWheel);
    },
  };
};



// WEBPACK FOOTER //
// ./src/facts/slider/facts-slider-timeline.component.js